(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Live brand line: the logos glide past on their own and loop forever. A hover, touch or arrow press pauses them. */
  (function () {
    function init(track) {
      if (track.dataset.liveReady) return;
      track.dataset.liveReady = '1';
      var items = Array.prototype.slice.call(track.children);
      if (items.length < 3) return;
      items.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
        track.appendChild(c);
      });
      track.classList.add('is-live');
      var speed = parseFloat(track.dataset.brandLive) || 30, pos = track.scrollLeft, last = 0, hold = false, visible = true, t;
      var firstClone = track.children[items.length];
      function half() { return (firstClone.offsetLeft - items[0].offsetLeft) || track.scrollWidth / 2; }
      function pauseFor(ms) { hold = true; clearTimeout(t); if (ms) t = setTimeout(function () { hold = false; pos = track.scrollLeft; }, ms); }
      function frame(now) {
        if (last) {
          var dt = Math.min(64, now - last), h = half();
          if (!hold && visible && !document.hidden) { pos += speed * dt / 1000; if (pos >= h) pos -= h; track.scrollLeft = pos; }
          else { pos = track.scrollLeft; if (pos >= h) { pos -= h; track.scrollLeft = pos; } }
        }
        last = now;
        requestAnimationFrame(frame);
      }
      track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pauseFor(0); });
      track.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hold = false; pos = track.scrollLeft; } });
      track.addEventListener('touchstart', function () { pauseFor(0); }, { passive: true });
      track.addEventListener('touchend', function () { pauseFor(2500); }, { passive: true });
      track.addEventListener('focusin', function () { pauseFor(0); });
      track.addEventListener('focusout', function () { pauseFor(1500); });
      var sec = track.closest('.section');
      if (sec) sec.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach(function (b) { b.addEventListener('click', function () { pauseFor(3000); }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(track);
      requestAnimationFrame(frame);
    }
    function run(root) { (root || document).querySelectorAll('[data-brand-live]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-explorer"] && !Shopify.designMode) return;
  try {
    
  /* Scent wheel: tap, drag or wait and the notes turn round; the chosen note shows in the middle. */
  (function () {
    function init(wheel) {
      if (wheel.dataset.ready) return;
      wheel.dataset.ready = '1';
      var dial = wheel.querySelector('[data-wheel-dial]');
      var orbs = Array.prototype.slice.call(wheel.querySelectorAll('[data-wheel-orb]'));
      var panels = Array.prototype.slice.call(wheel.querySelectorAll('[data-wheel-panel]'));
      var n = orbs.length, step = 360 / n, cur = 0, rot = 0;
      if (n < 3) return;
      function select(k) {
        k = ((k % n) + n) % n;
        var diff = ((k - cur) % n + n) % n;
        if (diff > n / 2) diff -= n;
        rot -= diff * step; cur = k;
        dial.style.setProperty('--rot', rot + 'deg');
        orbs.forEach(function (o, i) { o.classList.toggle('is-active', i === k); o.setAttribute('aria-pressed', i === k ? 'true' : 'false'); });
        panels.forEach(function (p, i) { p.hidden = i !== k; });
      }
      var interval = parseInt(wheel.dataset.interval, 10) || 4000, timer = 0, paused = false, visible = true;
      function tick() { clearTimeout(timer); timer = setTimeout(function () { if (!paused && visible && !document.hidden) select(cur + 1); tick(); }, interval); }
      function holdFor(ms) { paused = true; clearTimeout(wheel._h); wheel._h = setTimeout(function () { paused = false; }, ms); }
      wheel.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { clearTimeout(wheel._h); paused = true; } });
      wheel.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(wheel);

      var down = null, dragged = false;
      dial.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, id: e.pointerId }; dragged = false; });
      dial.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        if (!dragged && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - down.y)) { dragged = true; dial.classList.add('is-dragging'); try { dial.setPointerCapture(down.id); } catch (er) {} holdFor(8000); }
        if (dragged) dial.style.setProperty('--rot', (rot + dx * .45) + 'deg');
      });
      function up(e) {
        if (!down) return;
        var dx = e.clientX - down.x; down = null;
        if (!dragged) return;
        dial.classList.remove('is-dragging');
        var steps = Math.round((dx * .45) / step);
        rot += steps * step; cur = ((cur - steps) % n + n) % n;
        select(cur);
        setTimeout(function () { dragged = false; }, 0);
      }
      dial.addEventListener('pointerup', up);
      dial.addEventListener('pointercancel', up);
      orbs.forEach(function (o, i) { o.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); return; } holdFor(8000); select(i); }); });
      wheel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); holdFor(8000); select(cur + 1); orbs[cur].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); holdFor(8000); select(cur - 1); orbs[cur].focus(); }
      });
      wheel.addEventListener('shopify:block:select', function (e) { var k = orbs.indexOf(e.target); if (k > -1) { holdFor(60000); select(k); } });
      tick();
    }
    function run(root) { (root || document).querySelectorAll('[data-note-wheel]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
